/**
 * dayjs configurado como drop-in replacement de moment.
 *
 * Reemplazar `import moment from 'moment'` por
 *           `import moment from '@/util/dayjs-config'`
 * y todo el codigo existente (`moment().format()`, `moment().fromNow()`,
 * etc.) sigue funcionando igual.
 *
 * Por que dayjs:
 *  - moment 2.29 + locale es: ~71 KB brotli en el bundle.
 *  - dayjs core + locale es + plugin relativeTime: ~3 KB brotli.
 *  - Mismo API en 95% de casos. Se confirma con grep que el codigo solo
 *    usa: format, fromNow, locale, add, subtract, startOf, endOf, toDate,
 *    toISOString, valueOf, diff, isBefore. Todas en core o relativeTime.
 *  - Tree-shaking: dayjs es modular, plugins se importan solo si se usan.
 *
 * Diferencia notable: moment.locale('es') configura el locale GLOBAL.
 * dayjs.locale('es') tambien lo configura global. Pero llamadas como
 * `moment(d).locale('es')` (chained, instance-level) se traducen a
 * `dayjs(d).locale('es')` que tambien existe.
 */

import dayjs from 'dayjs'
import 'dayjs/locale/es'
import relativeTime from 'dayjs/plugin/relativeTime'
import customParseFormat from 'dayjs/plugin/customParseFormat'

// Plugins requeridos por usos detectados en el codigo:
//  - relativeTime para .fromNow() en filters.js + MapAlerts.vue
//  - customParseFormat para moment(str, 'YYYY-MM-DD HH:mm') en
//    AISearch.vue, FaceSearch.vue y otros views del merge edomex-test
dayjs.extend(relativeTime)
dayjs.extend(customParseFormat)

// Locale global por defecto: 'es'. Reemplaza moment.locale('es') que
// estaba en main.js. Si algun componente necesita formatos en otro
// idioma, puede llamar dayjs.locale('en') localmente o instanciar con
// locale especifico: dayjs(d).locale('en').
dayjs.locale('es')

export default dayjs
